import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  fieldSelect: {
    width: '31%',
    marginLeft: '2%'
  }
})
